export const endpoints = {
  session: {
    show: '/api/shop/v1/session',
    create: '/api/shop/v1/session',
    destroy: '/api/shop/v1/session',
  },
  otpVerifications: {
    create: '/api/shop/v1/otp_verifications',
    verify: '/api/shop/v1/otp_verifications/verify',
  },
  customers: {
    create: '/api/shop/v1/customers',
  },
  products: {
    index: (query = '') => `/api/shop/v1/products${query}`,
    show: (slug) => `/api/shop/v1/products/${slug}`,
  },
  cart: {
    show: '/api/shop/v1/cart',
    clear: '/api/shop/v1/cart',
  },
  cartItems: {
    create: '/api/shop/v1/cart_items',
    update: (id) => `/api/shop/v1/cart_items/${id}`,
    destroy: (id) => `/api/shop/v1/cart_items/${id}`,
  },
  orders: {
    create: '/api/shop/v1/orders',
    show: (number, token) => `/api/shop/v1/orders/${number}?token=${encodeURIComponent(token)}`,
  },
}
